import PropTypes from 'prop-types';
import React from 'react';

import {
  Accordion as ReactAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from 'react-accessible-accordion';

import { StyledAccordion } from './accordion.style';
import ContactList from '../../molecules/contact-list/contactList';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import Iframe from '../../atoms/Iframe/Iframe';

const renderComponent = block => ({
  text: <MixedCopy html={block.copy} />,
  contact: <ContactList person={block.contacts} insideAccordion />,
  iframe: <Iframe {...block.data} noRatio />
});

const Accordion = ({
  headline,
  subline,
  onChange = () => {},
  accordion: { sections },
  ...props
}) => (
  <StyledAccordion {...props}>
    {(headline || subline) && (
      <div className="accordion__headlines">
        {subline && (
          <Headline subline tag="h3">
            {subline}
          </Headline>
        )}
        {headline && (
          <Headline secondary tag="h2">
            {headline}
          </Headline>
        )}
      </div>
    )}
    <ReactAccordion allowZeroExpanded onChange={onChange} accordion={false}>
      {sections.map(section => (
        <AccordionItem key={section.subline} className="accordion__item">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion__heading">
              <div className="accordion__title-wrapper">
                <div className="accordion__icon">
                  <span />
                  <span />
                </div>
                <Headline tag="p" tertiary>
                  {section.subline}
                </Headline>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion__panel">
            {renderComponent(section)[section.type]}
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </ReactAccordion>
  </StyledAccordion>
);

Accordion.propTypes = {
  onChange: PropTypes.func,
  headline: PropTypes.string,
  subline: PropTypes.string,
  accordion: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        subline: PropTypes.string.isRequired,
        copy: PropTypes.string,
        contacts: PropTypes.arrayOf(PropTypes.shape())
      })
    ).isRequired
  }).isRequired
};

export default Accordion;
